import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconCloudOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, t, r, _, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--cloud-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Cloud Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M4.505 2.463a.5.5 0 0 1 .567-.423A4.004 4.004 0 0 1 8.209 4.5h.54a2.75 2.75 0 0 1 2.465 3.972.5.5 0 1 1-.896-.444A1.75 1.75 0 0 0 8.75 5.5h-.895a.5.5 0 0 1-.48-.357A3.004 3.004 0 0 0 4.929 3.03a.5.5 0 0 1-.423-.567ZM.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-1.398-1.4A2.683 2.683 0 0 1 8.75 10H4.5a4 4 0 0 1-2.405-7.198L.646 1.354a.5.5 0 0 1 0-.708Zm.938 6.064a3 3 0 0 1 1.228-3.191L8.292 9H4.5a3 3 0 0 1-2.916-2.29Z" }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const C = /* @__PURE__ */ u(f, [["render", h]]);
export {
  C as default
};
//# sourceMappingURL=cloud-off.js.map
